import React from 'react';
import PropTypes from 'prop-types';
import VerticalTab from '../VerticalTab';

import { TrialPanelWrapper, TrialPanelTab, TrialDays } from './styles';

const TrialPanel = ({ userId, trialDays, forceOpen }) => {
  const localStorageKey = `purpleGuide_trialPanel_${userId}`;
  const texts = i18n.locales[i18n.getLocale()]['purpleGuideTexts']['trialPanel'] || {};
  const trialDaysLeft = forceOpen ? 0 : trialDays;
  const trialEnd = trialDaysLeft === 0;
  const tab = ({ children, role, onClick }) => (
    <TrialPanelTab role={role} onClick={onClick} data-testid="vertical-tab">
      <TrialDays trialEnd={trialEnd}>{trialDaysLeft}</TrialDays>
      {children}
    </TrialPanelTab>
  );

  return trialDaysLeft < 0 ? null : (
    <VerticalTab
      id="trialPanel"
      order={2}
      texts={texts}
      defaultOpen={trialEnd}
      forceOpen={forceOpen}
      TabComponent={tab}
      WrapperComponent={TrialPanelWrapper}
      openClassName="trial-open"
      localStorageKey={trialEnd ? localStorageKey : ''}
    />
  );
};

TrialPanel.propTypes = {
  userId: PropTypes.string.isRequired,
  trialDays: PropTypes.number.isRequired,
  forceOpen: PropTypes.bool,
};

export default TrialPanel;
